var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownArrowHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.449,
    height: 14.449,
    viewBox: "0 0 14.449 14.449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-dropdown-circle",
    "data-name": "Icon ionic-ios-arrow-dropdown-circle",
    d: "M3.375,10.6A7.225,7.225,0,1,0,10.6,3.375,7.224,7.224,0,0,0,3.375,10.6ZM13.417,9.092a.673.673,0,0,1,.948,0,.662.662,0,0,1,.195.472.674.674,0,0,1-.2.476l-3.275,3.265a.67.67,0,0,1-.924-.021L6.838,9.971a.671.671,0,1,1,.948-.948L10.6,11.867Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#9f9f9f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowHeader);
export default __webpack_public_path__ + "static/media/down_arrow_header.e092496e11aec8adea6a5f225fb6f204.svg";
export { ForwardRef as ReactComponent };